import React from "react";
import {
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
} from "@chakra-ui/react";
import "./tokenconfig.css";

const TokenConfigs = ({formValues, setFormValues}) => {
  return (
    <div className="token-config-holder">
      <div className="linethrough">TOKEN CONFIGS</div>
      <div className="slider-holder">
        <div className="slider1">
          <label htmlFor="">Max Transaction Amount <span className="astrick">*</span></label>
          <div className="slider-and-value">
            <Slider aria-label="slider-ex-1" value={formValues.maxTransactionSlider} min={1} max={5} onChange={(value) => setFormValues({...formValues,maxTransactionSlider: value})}>
              <SliderTrack>
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb />
            </Slider>
            <div className="value">{formValues.maxTransactionSlider}%</div>
          </div>
        </div>
        <div className="slider2">
          <label htmlFor="">Max Wallet Amount <span className="astrick">*</span></label>
          <div className="slider-and-value">
            <Slider aria-label="slider-ex-1" value={formValues.maxWalletAmountSlider} min={0.5} max={5} step={0.1} onChange={(value) => setFormValues({...formValues,maxWalletAmountSlider: value})}>
              <SliderTrack>
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb />
            </Slider>
            <div className="value">{formValues.maxWalletAmountSlider}%</div>
          </div>
        </div>
        <div className="slider3">
          <label htmlFor="">SwapTokensAtAmount <span className="astrick">*</span></label>
          <div className="slider-and-value">
            <Slider aria-label="slider-ex-1" value={formValues.swapTokensAtAmountSlider} min={0.05} max={0.5} step={0.01} onChange={(value) => setFormValues({...formValues,swapTokensAtAmountSlider: value})}>
              <SliderTrack>
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb />
            </Slider>
            <div className="value">{formValues.swapTokensAtAmountSlider}%</div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenConfigs;
